<script lang="ts">
interface Props {
    showOverlay?: boolean;
}

let { showOverlay = false }: Props = $props();
</script>

<div class="overlay" class:overlay--enabled={showOverlay}></div>

<style lang="scss">
    .overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(#000, 0.7);
        display: none;
        z-index: 11; // above the page, below the contact form

        &--enabled {
            display: block;
        }
    }
</style>
